// extracted by mini-css-extract-plugin
export var container = "styles-module--container--2yezW";